export default "__VITE_ASSET__C$zZekUi__"